import type { FunctionComponent } from 'react';

export type JobAndSkillClusterIconProperties = {
    readonly isHighlighted: boolean;
};

export const AlertCircleIcon: FunctionComponent<JobAndSkillClusterIconProperties> = (properties) => {
    const { isHighlighted } = properties;
    const fillColor = isHighlighted ? '#F04438' : '#6E6E6C';

    return (
        // biome-ignore lint/a11y/noSvgWithoutTitle: suppressed due to migration
        <svg fill="none" height="14px" viewBox="0 0 14px 14px" width="14px" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_9961_74295)" id="alert-circle">
                <path
                    d="M7.00008 4.66663V6.99996M7.00008 9.33329H7.00592M12.8334 6.99996C12.8334 10.2216 10.2217 12.8333 7.00008 12.8333C3.77842 12.8333 1.16675 10.2216 1.16675 6.99996C1.16675 3.7783 3.77842 1.16663 7.00008 1.16663C10.2217 1.16663 12.8334 3.7783 12.8334 6.99996Z"
                    id="Icon"
                    stroke={fillColor}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.3"
                />
            </g>
            <defs>
                <clipPath id="clip0_9961_74295">
                    <rect fill="white" height="14" width="14" />
                </clipPath>
            </defs>
        </svg>
    );
};
